



import {style2} from '../signup/main.css'
import {style1} from './main.css'

import { LoadingOutlined, WarningOutlined, CheckOutlined } from '@ant-design/icons';
import { Space, Spin,  } from 'antd';
import { useLocation,useNavigate  } from "react-router-dom";

import callAPI from '../../comps/fetch/main'
import { useEffect, useState, useRef  } from 'react';
import logo from '../../images/logo.png'


function FbRdr() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isFBAPI, setIsFBAPI] = useState(undefined);
    const apiCalled = useRef(false); // Ref to prevent multiple calls

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.href.split('#')[1]);

    useEffect(() => {
        if (data?.code && data?.code == 404 && data?.code == "404") {
            setError(data?.message);
            return;
        }
        if (data?.code && data?.code !== 200 && data?.code !== "200") {
            setError( data?.message || "Sorry, that didn't work. Please try again.");
            return;
        }

        if (data?.data) {
            setError(null);
            const token = data.data.token;
            localStorage.setItem("token", token);
            sessionStorage.clear();
            
            localStorage.setItem("userData" , JSON.stringify(data.data.data))

            if (isFBAPI) {
                localStorage.setItem("pages", JSON.stringify(data.data.pages));
                let scopes = "instagram_basic,pages_manage_engagement,pages_read_user_content,pages_messaging,email,instagram_manage_comments,pages_show_list,business_management,instagram_manage_messages,pages_read_engagement,pages_manage_metadata,ads_read"
                localStorage.setItem("scopes", scopes);
                navigate('/insta-accounts');
            } else {
                window.location.assign("https://app.instantdm.com");
            }
        }
    }, [data]);

    useEffect(() => {
        if (isFBAPI === undefined || apiCalled.current) return;

        apiCalled.current = true; // Prevent duplicate calls
        let apiURL = isFBAPI
            ? `fb-api-login?llt=${queryParams.get('access_token')}&ref_code=${localStorage.getItem("refCode")}&user_tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}&fb_cid=${localStorage.getItem("fbclickid")}`
            : `fb-login?llt=${new URL(window.location.href).searchParams.get('code')}&ref_code=${localStorage.getItem("refCode")}&user_tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}&fb_cid=${localStorage.getItem("fbclickid")}`;

        setLoading(true);
        callAPI({
            url: apiURL,
            method: "GET",
            loadingState: setLoading,
            dataState: setData,
        });
    }, [isFBAPI]);

    useEffect(() => {
        setIsFBAPI(location.pathname === '/fb-api-rdr');
    }, [location.pathname]);

    return (
        <div className="fb-rdr">
            <div className="core-fb-rdr">
                <div className="flex-space-between">
                    <img className="logo" src="/logo192.png"alt="Logo" style={{ height: '62px', width: '62px' }} />
                    <div className="button-left">
                        <a href="https://instagram.com/instant.dm" target="_blank" rel="noopener noreferrer" className="help">Need Help?</a>
                    </div>
                </div>
                <div className="center-content">
                    {!error && loading && (
                        <p style={{ textAlign: 'center' }}>
                            <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />
                            Please wait, we're validating your request.
                        </p>
                    )}
                    {error && <p style={{ color: 'red', textAlign: 'center' }}><WarningOutlined /> {error}</p>}
                    {error && (
                        <a href={(isFBAPI || data?.code == 409) ? "/ig-connect" : "/ig-connect?show_ig_connect=true"} style={{ marginTop: '20px' }} className="connect-fb">
                            Try Reconnecting your IG Account
                        </a>
                    )}
                    {error && (
                        <a href="/" style={{ marginTop: '20px' }} className="help">
                            Go to Dashboard 
                        </a>
                    )}
                    {!error && !loading && (
                        <>
                            <p style={{ color: 'green', textAlign: 'center' }}><CheckOutlined /> It worked, start automating.</p>
                            <a href="/" style={{ marginTop: '20px' }} className="help">Go Home</a>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}



export default FbRdr;
